<template>
  <div>
    <nav id="topbar" class="navbar navbar-expand navbar-light p-0">
      <div class="top-sidenav media align-items-center bg-primary-3 text-white links-white" id="top-sidenav">
        <a class="navbar-brand" href="/">
          <img src="../../../assets/jumpstart/img/logos/hostomate-light.svg" width="150px;">
        </a>
        <toggler></toggler>
      </div>

      <!--<div class="d-flex flex-fill align-items-stretch">
        <div class="nav-link flex-fill">
          <search-form></search-form>
        </div>

        <ul class="navbar-nav my-3 my-lg-0 align-items-center">
          <profile-link></profile-link>
        </ul>
      </div>-->
    </nav>
  </div>
</template>

<script>
import Toggler from '../sidebar/components/Toggler.vue';
import SearchForm from './components/SearchForm.vue';
import ProfileLink from './components/ProfileLink.vue';

export default {
  name: 'Topbar',
  components:{
    Toggler, SearchForm, ProfileLink
  },
  mounted(){
    const dropdowns = document.querySelectorAll('#topbar .dropdown');
    document.addEventListener("click", this.closeDropdowns);
    dropdowns.forEach(d => {d.querySelector('a').addEventListener("click", this.toggleDropdown);})
  },
  methods: {

    closeDropdowns: function(e){
      const dropdowns = document.querySelectorAll('#topbar .dropdown');
      dropdowns.forEach(d => {
        d.contains(e.target) || d.querySelector('.dropdown-menu').classList.remove("show");
      });
    },

    toggleDropdown: function(e){
      const link = e.target;
      const menu = link.nextSibling;

      menu.classList.toggle("show");
      return;
    },
  }
}
</script>

<style>
  #topbar{
    box-shadow: 0 0 6px 0 rgba(50,50,50,.2);
  }
  .top-sidenav{
    width:100%;
    transition: 0.5s;
    left:0;
    overflow-x: hidden;
    height:70px;
    padding-left:1rem;
    padding-right:1rem;
    justify-content: space-between;
  }
  body.show-sidenav .top-sidenav{
    width:270px;
    justify-content: space-between;
  }

  @media screen and (min-width: 451px){
    .top-sidenav{
      width:88px;
      justify-content: center;
    }
    .top-sidenav > .navbar-brand{
      transition: all .3s ease-in;
    }
    body:not(.show-sidenav) .top-sidenav .navbar-brand{
      display:none;
      opacity:0
    }
  }

  @media screen and (max-width: 450px) {
    #topbar{
      box-shadow: none;
    }
    body.show-sidenav .top-sidenav, .top-sidenav{
      width:100%;
    }
    #topbar > *:not(.top-sidenav){
      display:none !important;
    }
  }
</style>
